import { render } from "./Imports.vue?vue&type=template&id=fd3b783a"
import script from "./Imports.vue?vue&type=script&lang=js"
export * from "./Imports.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Imports/Imports.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fd3b783a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fd3b783a', __exports__)) {
    api.reload('fd3b783a', __exports__)
  }
  
  module.hot.accept("./Imports.vue?vue&type=template&id=fd3b783a", () => {
    api.rerender('fd3b783a', render)
  })

}


export default __exports__